import isEmpty from "../validation/isEmpty";
const TeamValidation = (data) => {
  var errors = {};

  var titleLimit = 50;

  data.title = !isEmpty(data.title) ? data.title : "";
  if (isEmpty(data.title)) {
    errors.team = "Title is required";
  } else {
    if (data.title.length > titleLimit) {
      errors.team = `Title can not have more than ${titleLimit} character (${data.title.length})`;
    }
  }
  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export default TeamValidation;
